import { Link, useSearchParams } from 'react-router-dom';
import { Button, Card } from '../components/kit';
import './bayi/payment.css';

export function PaymentResult() {
  const [params] = useSearchParams();
  const status = params.get('status');
  const order = params.get('order');
  const bankMsg = params.get('msg')?.trim();
  const ok = status === 'ok';

  return (
    <div className="result-wrap">
      <Card className="result-card">
        <div className={`result-icon ${ok ? 'ok' : 'fail'}`}>{ok ? '✓' : '✕'}</div>
        <h1>{ok ? 'Ödeme başarılı' : 'Ödeme tamamlanamadı'}</h1>
        <p>
          {ok
            ? 'Tahsilatınız onaylandı. Dekontunuz e-posta/SMS ile iletilecektir.'
            : 'İşleminiz onaylanmadı. Kart bilgilerinizi kontrol edip tekrar deneyebilirsiniz.'}
        </p>
        {!ok && bankMsg && (
          <div className="result-bankmsg">
            <span className="result-bankmsg-label">Banka mesajı</span>
            <span className="result-bankmsg-text">{bankMsg}</span>
          </div>
        )}
        {order && <div className="result-order">Sipariş No: {order}</div>}
        {ok && order && (
          <div style={{ marginBottom: 16 }}>
            <a href={`/api/payments/${encodeURIComponent(order)}/dekont`} target="_blank" rel="noreferrer">
              <Button variant="secondary">Dekontu İndir (PDF)</Button>
            </a>
          </div>
        )}
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center', marginTop: 8 }}>
          <Link to="/odemelerim"><Button variant="secondary">Ödemelerim</Button></Link>
          <Link to="/odeme"><Button>{ok ? 'Yeni Ödeme' : 'Tekrar Dene'}</Button></Link>
        </div>
      </Card>
    </div>
  );
}
